var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "New Building",
        visible: _vm.$parent.showForm,
        width: "600px"
      },
      on: {
        "update:visible": function($event) {
          return _vm.$set(_vm.$parent, "showForm", $event)
        }
      }
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "supplier_id" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "Supplier wählen",
                            remote: "",
                            "default-first-option": ""
                          },
                          model: {
                            value: _vm.form.supplier_id,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "supplier_id", $$v)
                            },
                            expression: "form.supplier_id"
                          }
                        },
                        _vm._l(_vm.get_suppliers, function(supplier) {
                          return _c("el-option", {
                            key: supplier.id,
                            attrs: {
                              label: supplier.supplier_name,
                              value: supplier.id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 5 } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Street", prop: "street" } },
                    [
                      _c("el-input", {
                        attrs: { "auto-complete": "off" },
                        model: {
                          value: _vm.form.street,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "street", $$v)
                          },
                          expression: "form.street"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "house_number", label: "Number" } },
                    [
                      _c("el-input", {
                        attrs: { "auto-complete": "off", type: "number" },
                        model: {
                          value: _vm.form.house_number,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "house_number", $$v)
                          },
                          expression: "form.house_number"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Suffix" } },
                    [
                      _c("el-input", {
                        attrs: { "auto-complete": "off" },
                        model: {
                          value: _vm.form.suffix,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "suffix", $$v)
                          },
                          expression: "form.suffix"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Default panel price" } },
                    [
                      _c("el-input", {
                        attrs: { "auto-complete": "off" },
                        model: {
                          value: _vm.form.default_panel_price,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "default_panel_price", $$v)
                          },
                          expression: "form.default_panel_price"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", [
                _c("h3", { staticStyle: { "font-size": "16px" } }, [
                  _vm._v("Felder und Panels Hinzufügen")
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.form.fields, function(field, index) {
            return _c(
              "el-row",
              { key: index },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "fields." + index + ".panels_number",
                          label: "Field " + (index + 1)
                        }
                      },
                      [
                        _c("el-input-number", {
                          attrs: {
                            placeholder: "Number of panels",
                            min: 1,
                            type: "number"
                          },
                          model: {
                            value: field.panels_number,
                            callback: function($$v) {
                              _vm.$set(field, "panels_number", $$v)
                            },
                            expression: "field.panels_number"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 2, offset: 1 } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary", plain: "" },
                        on: {
                          click: function($event) {
                            return _vm.addBuildingField()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    Hinzufügen\n                "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 1, offset: 1 } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "danger", plain: "" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.removeBuildingField(index)
                          }
                        }
                      },
                      [_vm._v("\n                    Delete\n                ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitForm("form")
                }
              }
            },
            [
              _vm._v("\n            Bestätigen\n            "),
              _vm.formSubmitted
                ? _c("i", { staticClass: "el-icon-loading" })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("el-button", { on: { click: _vm.closeForm } }, [
            _vm._v("Abbrechen")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07e73ec3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e73ec3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/buildings/BuildingForm.vue
// module id = null
// module chunks = 